/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}
/**
 * @param {string} str
 * @returns {Boolean}
 *
 */
export function validPassword(str) {
  //以字母开头，长度在6~18之间，只能包含字母、数字和下划线
  let reg = /^[a-zA-Z]\w{5,17}$/
  return reg.test(str)
}

export function passwordValidator(rule, value, callback) {
  if (!validPassword(value)) {
    callback(new Error('密码格式不对'))
  } else {
    callback()
  }
}
